<div class="roles">
    <Card dis-hover>
        <div class="page-body">
            <Form ref="queryForm" :label-width="90" label-position="left" inline>
<!--                <Row :gutter="16">-->
<!--                    <Col span="8">-->
                        <FormItem :label="L('RoleName')+':'" >
                            <Input v-model="filters[0].Value" :placeholder="L('RoleName')"></Input>
                        </FormItem>
<!--                    </Col>-->
<!--                    <Col span="8">-->
                        <FormItem :label="L('DisplayName')+':'" >
                            <Input v-model="filters[1].Value" :placeholder="L('DisplayName')"></Input>
                        </FormItem>
<!--                    </Col>-->
<!--                    <Col span="8">-->
                        <FormItem :label="L('Description')+':'" >
                            <Input v-model="filters[2].Value" :placeholder="L('Description')"></Input>
                        </FormItem>
<!--                    </Col>-->
<!--                    <Col span="8">-->
                        <FormItem label="权限：" >
                            <AutoComplete transfer :data="[]" v-model="selectedPermissions"
                                          @on-clear="handlePermissionClear" :placeholder="L('Description')">
                                <div style="padding:0 10px;">
                                    <Tree ref="permissionTree" :data="permissions"
                                          @on-check-change="handlePermissionChecked" show-checkbox></Tree>
                                </div>
                            </AutoComplete>
                        </FormItem>
<!--                    </Col>-->
<!--                </Row>-->
                <Row>
                    <Button @click="create" v-if="hasPermission('Pages.Administration.Roles.Create')" icon="ios-add"
                            type="default">{{L('Add')}}
                    </Button>
                    <Button icon="ios-search" type="default" @click="search"
                            class="toolbar-btn">{{L('Find')}}
                    </Button>
                </Row>
            </Form>
            <div class="margin-top-10">
                <Table :loading="loading" :columns="columns" :no-data-text="L('NoDatas')" border :data="list">
                </Table>
                <Page show-sizer class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange"
                      @on-page-size-change="pagesizeChange" :page-size="pageSize" :current="currentPage"></Page>
            </div>
        </div>
    </Card>
    <CreateOrUpdateRole v-model="createModalShow" @save-success="getpage"></CreateOrUpdateRole>
    <RoleViewModal ref="viewModal"></RoleViewModal>
</div>
